import React from 'react';
import styles from './ChartErrorView.module.scss';

interface ChartErrorViewProps {
  metricName: string;
  error?: Error;
}

export default function ChartErrorView({ metricName, error }: ChartErrorViewProps) {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIcon}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2"/>
          <line x1="15" y1="9" x2="9" y2="15" stroke="#ef4444" strokeWidth="2"/>
          <line x1="9" y1="9" x2="15" y2="15" stroke="#ef4444" strokeWidth="2"/>
        </svg>
      </div>
      
      <div className={styles.errorContent}>
        <h3 className={styles.errorTitle}>Erreur de chargement</h3>
        <p className={styles.errorMessage}>
          Impossible de charger les données pour <strong>{metricName}</strong>
        </p>
        {error && (
          <details className={styles.errorDetails}>
            <summary className={styles.errorSummary}>Détails de l'erreur</summary>
            <p className={styles.errorText}>{error.message}</p>
          </details>
        )}
        <button 
          className={styles.retryButton}
          onClick={() => window.location.reload()}
        >
          Réessayer
        </button>
      </div>
    </div>
  );
}
